<template>
    <section class="sports-window">
        <div class="wrap">
            <div class="new-close" @click="changeState()">
                <img src="@/assets/images/icons/icon_close.svg">
            </div>
            <div class="input-search">
                <input type="search" placeholder="Поиск" v-model="search">
                <img src="/img/search.6d7a391a.svg" width="22px">
            </div>
            <div class="sports-window-body">
                <Sports v-if="sports" :sports="getSports" :type="'all'" @changeSports="changeSports($event)" />
            </div>
            <div class="sports-window-new">
                <p>Или предложите свой вид спорта</p>
                <input type="text" v-model="new_category" @keydown.enter="newCategory()"/>
            </div>
        </div>
        <div class="sports-window__button button" @click="changeState(true)">Изменить категории</div>
    </section>
</template>
<script>
export default {
    name: 'transport',
    props: {
        actives: {
            type: Array,
            required: true
        }
    },
    components: {
        Sports: () => import('@/components/Filters/SportsProfile.vue')
    },
    computed: {
        getSports() {
            let filtered = [];
            this.sports.forEach(element => {
                this.actives.find(active => active.id === element.id) ? element.active = true : '';
                filtered.push(element)
            });
            return this.filteredSports(filtered)
        }
    },
    data () {
        return {
            sports: null,
            new_category: null,
            search: null
        }
    },
    methods: {
        filteredSports() {
            return this.search 
                ? this.sports.filter(sport => sport.ru.toUpperCase().indexOf(this.search.toUpperCase()) !== -1 )
                : this.sports
        },
        async fetchSports () {
            this.sports = await this.$store.dispatch('fetchSports');
        },
        newCategory () {
            let upperText = this.new_category.toUpperCase();
            upperText.length < 26 && upperText.length > 2 
                ? this.sendNewCategory(upperText) 
                : this.$store.dispatch('addError', { message: 'Не подходящий размер сообщения' });
        },
        async sendNewCategory(title) {
            await this.$store.dispatch('sendNewCategory', {title})
                .then(() => {
                    this.new_category = null
                    this.$store.dispatch('addNotification', { message: 'Спасибо! Я рассмотрю ваше предложение 😎' });
                });
        },
        changeState (save) {
            this.$emit('closeSports', save)
        },
        changeSports (element) {
            this.$emit('changeSports', element)
        }
    },
    mounted () {
        this.fetchSports()
    }
}
</script>